import { generateRandomString } from '@fly/shared';
import { apiSlice } from '@fly/store';

type TrafficValue = [string, number];

interface TrafficResultEntry {
  date: string;
  values: TrafficValue[];
}

export interface TrafficResponse {
  technical_server_name: string;
  start_date: string;
  non_inclusive_end_date: string;
  group_by: string;
  partition_by: string;
  nonce: string;
  result: TrafficResultEntry[];
}

export interface GetTrafficParams {
  technicalServerName: string;
  partitionBy: string;
  groupBy: string;
  startDate: string;
  endDate: string;
}

interface StorageResultEntry {
  date: string;
  value: number;
}

export interface StorageResponse {
  technical_server_name: string;
  start_date: string;
  non_inclusive_end_date: string;
  partition_by: string;
  nonce: string;
  result: StorageResultEntry[];
}

export interface GetStorageParams {
  technicalServerName: string;
  partitionBy: string;
  startDate: string;
  endDate: string;
}

export const usageService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTraffic: builder.query<TrafficResponse, GetTrafficParams>({
      query: ({
        technicalServerName,
        partitionBy,
        groupBy,
        startDate,
        endDate,
      }) => ({
        api: 'usage',
        url: `traffic/${technicalServerName}`,
        method: 'GET',
        config: {
          params: {
            partition_by: partitionBy,
            group_by: groupBy,
            start_date: startDate,
            end_date: endDate,
            nonce: generateRandomString(),
          },
        },
      }),
    }),
    getStorage: builder.query<StorageResponse, GetStorageParams>({
      query: ({ technicalServerName, partitionBy, startDate, endDate }) => ({
        api: 'usage',
        url: `storage/${technicalServerName}`,
        method: 'GET',
        config: {
          params: {
            partition_by: partitionBy,
            start_date: startDate,
            end_date: endDate,
            nonce: generateRandomString(),
          },
        },
      }),
    }),
  }),
});

export const { useGetTrafficQuery, useGetStorageQuery } = usageService;
